import React from "react";
import { Spin } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import { THEME } from "../../styles/colors";

const CustomLoadingIcon = () => (
  <Spin
    indicator={
      <SettingOutlined style={{ fontSize: 48, color: THEME.primary }} spin />
    }
  />
);

export default CustomLoadingIcon;
